import { v2Colors } from "../../tokens/color";
export const sizeStyles = {
    micro: {
        width: 30,
        height: 30,
        fontSize: '1.8rem',
    },
    small: {
        width: 40,
        height: 40,
        fontSize: '2rem',
    },
    medium: {
        width: 48,
        height: 48,
        fontSize: '2.4rem',
    },
    large: {
        width: 58,
        height: 58,
        fontSize: '2.5rem',
    },
};
export const shapeStyles = {
    square: {
        borderRadius: '4px',
    },
    round: {
        borderRadius: '100px',
    },
};
export const baseStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    userSelect: 'none',
    position: 'relative',
    verticalAlign: 'middle',
    boxSizing: 'border-box',
    transition: 'background-color 300ms ease, box-shadow 300ms ease, color 300ms ease',
    border: 0,
    outline: 0,
    background: 'none',
    textDecoration: 'none',
    padding: 0,
    '& svg': {
        height: '1em',
        width: '1em',
        color: 'currentcolor',
        '& path': {
            fill: 'currentcolor',
        },
    },
    '&[data-disabled]': {
        pointerEvents: 'none',
        color: v2Colors.text.disabled,
    },
};
